import cn from 'classnames'
import { ElementType } from 'react'

import styles from './Arrow.module.scss'
import { sizesMap } from './lib/constants'
import { ArrowDirection, ArrowSizes } from './lib/types'

import ArrowIcon from '~shared/icons/24/arrow.svg'
import DoubleArrowIcon from '~shared/icons/24/double-arrow.svg'

interface ArrowProps {
  component?: ElementType
  direction?: ArrowDirection
  double?: boolean
  size?: ArrowSizes
  className?: string
}

function Arrow({
  component: Component = 'span',
  double,
  direction = 'bottom',
  size = 'md',
  className,
  ...props
}: ArrowProps) {
  const sizeValue = sizesMap[size]
  const ArrowComponent = double ? DoubleArrowIcon : ArrowIcon

  return (
    <Component className={cn(styles.root, direction && styles[direction], className)} {...props}>
      <ArrowComponent width={sizeValue} height={sizeValue} viewBox="0 0 24 24" />
    </Component>
  )
}

export default Arrow
